import { FC, useEffect, useState } from "react";

import HeroSection from "../sections/HeroSection";
import ServicesSection from "../sections/ServicesSection";
import ContactSection from "../sections/ContactSection";
import FooterSection from "../sections/FooterSection";

import { useProfesional } from "../context/ProfesionalContext";
import { safeFetch } from "@/api/safeFetch";
import { getGlobalThemeStyles } from "../core/themesStyles";

const LandingPage: FC = () => {
  const { landingData, loading, perfilId } = useProfesional();

  const [sections, setSections] = useState<Record<string, any>>({});

  const loadSections = async () => {
    if (!perfilId) return;

    try {
      const res = await safeFetch(`/api/landing/${perfilId}`);

      const data = await res.json();

      setSections(data || {});
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const handleUpdate = () => {
      loadSections();
    };

    window.addEventListener("landingUpdated", handleUpdate);

    return () => {
      window.removeEventListener("landingUpdated", handleUpdate);
    };
  }, [perfilId]);

  useEffect(() => {
    if (!perfilId) return;
    loadSections();
  }, [perfilId]);

  if (loading) return <div>Cargando...</div>;
  if (!landingData) return null;
  return (
    <div
      className="space-y-8 scrollbar-hide"
      style={getGlobalThemeStyles(landingData.theme)}
    >
      <HeroSection
        data={landingData}
        section={sections.hero || { props: {} }}
      />

      <ServicesSection data={landingData} section={sections.services} />

      <ContactSection data={landingData} section={sections.contact} />

      <FooterSection data={landingData} section={sections.footer} />
    </div>
  );
};

export default LandingPage;
